<div class="footer-root">
  <div class="links-row">
    <div class="platform-name">© Talent Cloud</div>
    <div class="link"><a href="/legal/terms" target="_blank">Правила пользования</a></div>
    <div class="link"><a href="/legal/privacy" target="_blank">Политика конфиденциальности</a></div>
  </div>
</div>
